import React, {useEffect, useRef, useState} from 'react';

import {utils} from '../utils';
import {theme} from '../constants';

interface ButtonProps {
  title: string;
  /**
   * Kalau handler mengembalikan Promise (async), tombol OTOMATIS terkunci sampai Promise selesai —
   * tap kedua dst. diabaikan. Mencegah submit/upload dobel saat jaringan lambat.
   */
  onClick?: () => unknown;
  colorScheme?: 'dark' | 'light';
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  title,
  style,
  onClick,
  colorScheme = 'dark',
  containerStyle,
  disabled = false,
}) => {
  // Ref = terkunci seketika (sebelum re-render), state = utk tampilan redup
  const busyRef = useRef(false);
  const [busy, setBusy] = useState(false);
  const mountedRef = useRef(true);
  useEffect(() => () => { mountedRef.current = false; }, []);

  const handleClick = () => {
    if (disabled || busyRef.current || !onClick) return;
    const result = onClick();
    if (result && typeof (result as Promise<unknown>).finally === 'function') {
      busyRef.current = true;
      setBusy(true);
      (result as Promise<unknown>)
        .catch(() => {}) // error sudah ditangani handler; jangan jadi unhandled rejection
        .finally(() => {
          busyRef.current = false;
          if (mountedRef.current) setBusy(false);
        });
    }
  };

  const inactive = disabled || busy;
  return (
    <div style={{...containerStyle}}>
      <button
        onClick={handleClick}
        disabled={inactive}
        aria-busy={busy}
        style={{
          width: '100%',
          color:
            colorScheme === 'dark' ? theme.colors.white : theme.colors.mainDark,
          height: 40,
          textAlign: 'center',
          fontSize: 16,
          borderRadius: 10,
          textTransform: 'capitalize',
          border: colorScheme === 'dark' ? 'none' : '1px solid #FFD9C3',
          background:
            colorScheme === 'dark' ? theme.colors.mainDark : '#FFD9C3',
          ...utils.flexCenter(),
          ...theme.fonts.SourceSansPro_600SemiBold,
          ...style,
          ...(inactive ? {opacity: 0.6, cursor: 'not-allowed'} : {}),
        }}
      >
        {title}
      </button>
    </div>
  );
};
